import { JobCreateFormFields } from './types';

type AmountField =
  | 'totalSquareFootage'
  | 'interiorOptionCost'
  | 'exteriorOptionCost'
  | 'trimOptionCost'
  | 'exteriorSidingPaintAmount';

export type JobCreateFormInput = Omit<JobCreateFormFields, AmountField> &
  Partial<Record<AmountField, number | string>>;

const toTwoDecimals = (value: number | string): number =>
  Number(parseFloat(String(value)).toFixed(2));

export const toJobCreateFields = (fields: JobCreateFormInput) => {
  const {
    model: modelId,
    block,
    builder: _removedBuilder,
    buildingName: _removedBuildingName,
    subdivision: _removedSubdivision,
    latitude: _removedLatitude,
    longitude: _removedLongitude,
    totalSquareFootage,
    interiorOptionCost,
    exteriorOptionCost,
    trimOptionCost,
    exteriorSidingPaintAmount,
    ...restFields
  } = fields;

  return {
    modelId,
    block: block === '' ? undefined : block,
    ...restFields,
    ...(totalSquareFootage && {
      totalSquareFootage: toTwoDecimals(totalSquareFootage),
    }),
    ...(interiorOptionCost && {
      interiorOptionCost: toTwoDecimals(interiorOptionCost),
    }),
    ...(exteriorOptionCost && {
      exteriorOptionCost: toTwoDecimals(exteriorOptionCost),
    }),
    ...(fields.hasTrimOptions &&
      trimOptionCost && { trimOptionCost: toTwoDecimals(trimOptionCost) }),
    ...(fields.hasExteriorPaint &&
      exteriorSidingPaintAmount && {
        exteriorSidingPaintAmount: toTwoDecimals(exteriorSidingPaintAmount),
      }),
  };
};
